enum UploadableFileStatus {
    WAITING = 1,
    UPLOADED,
    UPLOADING,
    ERROR,
}

export default UploadableFileStatus;
